import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { requestNewVerifyEmail } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { Button, Modal, ModalActions, ModalContent, ModalTitle } from '@uplift/ui-v2';
import { useCallback } from 'react';

const useStyles = makeStyles()(theme => ({
  footer: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2, 3),
  },
}));

export type ExpiredEmailVerifyLinkProps = {
  open: boolean;
  onClose: () => void;
};

export const ExpiredEmailVerifyLink: React.VFC<ExpiredEmailVerifyLinkProps> = ({ open, onClose }) => {
  const { classes } = useStyles();
  const l10n = useL10n();

  const handleRequestNewLink = useCallback(async () => {
    await requestNewVerifyEmail();

    onClose();
  }, [ onClose ]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="sm"
    >
      <ModalTitle>
        {l10n.dashboard.emailVerification.expired}
      </ModalTitle>
      <ModalContent>
        <Typography>
          {l10n.dashboard.emailVerification.pleaseRequest}
        </Typography>
      </ModalContent>
      <ModalActions className={classes.footer}>
        <Button fullWidth variant="contained" color="secondary" onClick={handleRequestNewLink}>
          {l10n.dashboard.emailVerification.requestNew}
        </Button>
      </ModalActions>
    </Modal>
  );
};
